/**
 * 이메일 유효성 검사 결과
 */
export interface EmailValidation {
  isValid: boolean;
  error?: string;
}

/**
 * 이메일 유효성 검증
 * @param value - 이메일 주소
 * @returns 유효성 검사 결과
 *
 * @example
 * validateEmail('test@example.com') // { isValid: true }
 * validateEmail('invalid-email') // { isValid: false, error: '이메일 형식이 올바르지 않습니다' }
 */
export const validateEmail = (value: string): EmailValidation => {
  if (!value || value.length === 0) {
    return { isValid: false, error: '' };
  }

  // 이메일 정규식 패턴 검증
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isValid = emailRegex.test(value);

  if (!isValid) {
    return { isValid: false, error: '이메일 형식이 올바르지 않습니다' };
  }

  return { isValid: true };
};
